<template>
  <div style="padding-left: 1.75rem">
    <div class="col2_head">
      <router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link>
      {{ $route.name }}
      <div class="subHeadTitle">
        {{
          getProcedureTypes?.[$route.params.procedureType]
            ? getProcedureTypes?.[$route.params.procedureType].name
            : ""
        }}
      </div>
    </div>
    <template v-if="PERMISIONS.list">
      <Table
        :key="tableReload"
        :reloadCount="tableReload"
        :Data="tableData"
        @Btn7="viewReferences"
        @Btn8="viewAssignmentDocuments"
        @Btn9="viewVerbalProcess"
        @Btn10="viewAnnouncement"
        @previousPage="setPage"
        @nextPage="setPage"
        @fullReload="reloadPage"
        @readFilteredData="filteredDataManager"
        @filterQuery="tableFilterManager"
      >
      </Table>
    </template>
    <template v-else>
      <h3 style="display: flex; flex-direction: column; align-items: center">
        <span style="font-size: 4rem">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        Acces interzis
      </h3>
    </template>
  </div>
</template>

<script>
import PermisionsMixin from "@/mixins/assignmentsPermMixin.js";
import updateRoleStatus from "../mixins/updateUserRoleStatus.js";
import { GET_PAAP_CENTRALIZATION_FOR_ASSIGNMENT_PAGINATED } from "../api.js";
import { mapMutations, mapGetters } from "vuex";
import Table from "@/components/Table";

export default {
  $Title() {
    return `ConectX - ${this.$route.name}`;
  },
  components: {
    Table,
  },
  mixins: [PermisionsMixin, updateRoleStatus],
  data() {
    return {
      dataLoading: false,
      tableData: {
        ready: 1,
        options: {
          searchModule: (x, y, _, b) => {
            return GET_PAAP_CENTRALIZATION_FOR_ASSIGNMENT_PAGINATED(
              x,
              y,
              this.currentProcedureId,
              b,
            );
          },
          partialDisableFixedCols: window.innerWidth < 500 ? [2, 1] : false,
          refresh: true,
          specialActions: { 1: "showSubTableSlot" },
        },
        head: [
          {
            title: "NR.",
            minimize: 2,
            sort: true,
            fixed: {
              left: true,
            },
          },
          {
            title: "Denumire",
            sort: true,
            queryKey: "name",
            bottomHead: {
              quikFiltre: true,
            },
          },
          {
            title: "CPV - Denumire",
            queryKey: "cpvCode",
            bottomHead: {
              quikFiltre: "string",
            },
          },

          {
            title:
              "Procedura stabilită/instrumente specifice pentru derularea procesului de achiziție",
            queryKey: "procedureType.name",
            bottomHead: {
              quikFiltre: "string",
            },
          },
          {
            title: "Rezultatul procedurii",
            queryKey: "procedureResult",
            bottomHead: {
              quikFiltre: "string",
            },
          },
          {
            title: "Valoare estimată(LEI fără TVA)",
            queryKey: "totalValueWithoutTva",
            bottomHead: {
              quikFiltre: "number",
            },
          },
          {
            title: "Sursa de finanțare",
            queryKey: "financingSource.sourceName",
            bottomHead: {
              quikFiltre: "string",
            },
          },
          {
            title: "Data (luna) estimată pentru inițierea proceduri",
            queryKey: "estimateInitProcedureDate",
            bottomHead: {
              quikFiltre: Date,
            },
          },
          {
            title:
              "Data (luna) estimată pentru atribuirea contractului de achiziție publică/semnarea acordului-cadru",
            queryKey: "estimateDateForSignContract",
            bottomHead: {
              quikFiltre: Date,
            },
          },
          {
            title: "Modalitatea de derulare a procedurii de atribuire",
            queryKey: "modalityToProcessProcedure",
            bottomHead: {
              quikFiltre: "string",
            },
          },
          {
            title: "Persoana responsabilă cu aplicarea procedurii de atribuire",
            queryKey: "responsablePersonRole",
            bottomHead: {
              quikFiltre: "string",
            },
          },
          {
            title:
              "Data introducerii procedurii în Programul anual al achizițiilor publice",
            queryKey: "dateForLastProcedureAdded",
            bottomHead: {
              quikFiltre: Date,
            },
          },
          {
            spacer: true,
            minimize: 1,
            fixed: {
              right: true,
            },
            bottomHead: {
              quikFiltre: "clear",
            },
          },
        ],
        body: [],
      },
      currentPage: this.getPaginatedParams(),
      totalItemsLength: 0,
      tableFilter: {
        query: "",
        baseQuery: "",
      },
      totalRecords: 0,
      tableReload: 1,
      financingSource: [],
    };
  },
  methods: {
    ...mapMutations({
      addWindow: "addWindow",
      saveData: "setPaapCentralizationTableData",
    }),
    viewReferences(item) {
      const find = this.getPaapCentralizationTableData.find(
        (e) => e.index === item,
      );

      this.$router.push(`${this.$route.path}/${find.id}`);
    },
    viewAssignmentDocuments(item) {
      const find = this.getPaapCentralizationTableData.find(
        (e) => e.index === item,
      );

      this.$router.push(`${this.$route.path}/${find.id}/achizitii`);
    },

    viewVerbalProcess(item) {
      const find = this.getPaapCentralizationTableData.find(
        (e) => e.index === item,
      );

      this.$router.push(`${this.$route.path}/${find.id}/proces-verbal`);
    },

    viewAnnouncement(item) {
      const find = this.getPaapCentralizationTableData.find(
        (e) => e.index === item,
      );

      this.$router.push(`${this.$route.path}/${find.id}/anunt`);
    },
    reloadPage() {
      if (this.isLoadingMenu) return;

      this.saveData([]);
      this.tableData.body.splice(0);
      this.tableReload = 1;
      this.totalItemsLength = 0;
      this.totalRecords = 0;
      this.currentPage = this.getPaginatedParams();
      this.dataLoading = false;
      this.tableFilter.query = "";
      this.managePages();
    },
    setPage(from, to) {
      if ((!parseInt(from) && from !== 0) || (!parseInt(to) && to !== 0)) {
        return;
      }

      this.currentPage.from = from;
      this.currentPage.to = to;

      this.managePages();
    },
    async getPaapCentralizationData(showPerPage, page) {
      let prepare = [];

      let response = await GET_PAAP_CENTRALIZATION_FOR_ASSIGNMENT_PAGINATED(
        page,
        showPerPage,
        this.currentProcedureId,
        this.tableFilter.query || false,
      );
      if (Number.isInteger(response?.data?.recordsQuantity)) {
        this.totalItemsLength = response.data.recordsQuantity;
        this.tableData.options.totalItems = response.data.recordsQuantity;
      }

      prepare = this.prepareData(response.data.result);
      return prepare;
    },

    async managePages(changePage) {
      if (this.dataLoading) {
        return;
      }
      this.dataLoading = true;
      let data = this.getPaapCentralizationTableData;

      const { from, to } = this.currentPage;
      const show = to - from;
      const currentPage = from / (to - from) + 1;
      const totalItems = this.totalItemsLength;

      if (to >= totalItems && data.length && changePage !== true) {
        return;
      }

      let uploadPages = [];
      let reloadRowsAfterChangeShow = false;

      if (currentPage > 0) {
        if (!data[from]) {
          uploadPages.push(currentPage);
        } else if (data[from] && !data[to - 1]) {
          this.data.body = [];
          data = [];
          reloadRowsAfterChangeShow = true;
          uploadPages.push(currentPage);
        }
      }
      if (Math.ceil(totalItems / show) - currentPage > 0) {
        if (!data[to]) {
          uploadPages.push(currentPage + 1);
        }
      }

      if (currentPage - 1 >= 1) {
        if (!data[from - show]) {
          uploadPages.push(currentPage - 1);
        }
      }

      if (
        this.tableReload === 1 &&
        uploadPages.length < 2 &&
        uploadPages.indexOf(currentPage + 1) == -1
      ) {
        uploadPages.push(currentPage + 1);
      }

      if (uploadPages.length) {
        let preparation = [];
        let prepare = [];
        let i = 0;
        for (const page of uploadPages) {
          const getPage = await this.getPaapCentralizationData(show, page);
          preparation.push(getPage);
          i++;
        }
        const lastRowIndex = data[data.length - 1]
          ? data[data.length - 1].index + 1
          : 0;

        preparation = preparation.flat(1);

        preparation.forEach((e, i) => {
          e.row.splice(0, 0, {
            val: lastRowIndex + (i + 1),
            border: "right",
          });

          prepare.push(
            Object.assign([...e.row], {
              _Data: e.data,
            }),
          );
        });
        data.push(preparation);
        data = data.flat(1);

        data.forEach((e, i) => {
          e.NR = i;
          e.index = i;
        });

        this.saveData(data);
        this.tableData.body =
          this.tableData.body.concat(prepare).length === 0
            ? [false]
            : this.tableData.body.concat(prepare);
        if (reloadRowsAfterChangeShow || this.tableReload == 1)
          this.tableReload++;
      } else if (!this.tableFilter.query) {
        let prepare = [];
        data.forEach((e) => {
          prepare.push(
            Object.assign([...e.row], {
              _Data: e.data,
            }),
          );
        });
      }

      this.dataLoading = false;
    },

    filteredDataManager(data, callback) {
      if (Number.isInteger(data?.data?.recordsQuantity)) {
        this.totalItemsLength = data.data.recordsQuantity;
      }
      if (Array.isArray(data?.data?.result)) {
        callback([
          this.prepareData(data.data.result, {
            minimize: true,
          }),
          data.data.recordsQuantity,
        ]);
        this.saveData(
          this.prepareData(data.data.result, {
            minimize: false,
          }),
        );
        this.tableData.options.totalItems = parseInt(data.data.recordsQuantity);
        this.currentPage = {
          from: 0,
          to: localStorage.getItem("tableShowPerPage")
            ? parseInt(localStorage.getItem("tableShowPerPage"))
            : 15,
        };
        this.dataLoading = false;
      } else {
        callback([false]);
      }
    },
    tableFilterManager(newQuery) {
      if (this.isString(newQuery)) {
        this.tableFilter.query = newQuery;
      }
    },
    reload() {
      this.tableReload++;
    },

    prepareData(rows, o = {}) {
      const preparations = [];

      let i = 1;
      for (const row of rows) {
        let estimateInitProcedureDate = "-";

        if (row.estimateInitProcedureDate) {
          estimateInitProcedureDate = new Date(
            row.estimateInitProcedureDate,
          ).toLocaleString("ro-ro", { month: "long", year: "numeric" });
        }

        let estimateDateForSignContract = "-";

        if (row.estimateDateForSignContract) {
          estimateDateForSignContract = new Date(
            row.estimateDateForSignContract,
          ).toLocaleString("ro-ro", { month: "long", year: "numeric" });
        }

        let dateForLastProcedureAdded = "-";

        if (row.dateForLastProcedureAdded) {
          dateForLastProcedureAdded = this.toDate(
            row.dateForLastProcedureAdded,
          );
        }

        const preparation = [
          row.name || "-",
          row.cpvCode + " - " + row.cpvCodeName || "-",
          row.procedureType?.name || "-",
          row.procedureResult || "-",
          this.toPriceFormat(row.totalValueWithoutTva),
          row.financingSource?.sourceName || "-",
          estimateInitProcedureDate,
          estimateDateForSignContract,
          row.modalityToProcessProcedure || "-",
          this.readUserObject(row.responsablePersonRole?.user) +
            (row.responsablePersonRole?.department?.name
              ? ` — ${row.responsablePersonRole?.department?.name}`
              : "") +
            (row?.responsablePersonRole?.role
              ? ` — ${this.changeRoleView(row.responsablePersonRole?.role)}`
              : "") || "-",
          dateForLastProcedureAdded,
        ];

        const prepareBtn = [[7, "Referate"]];

        if (row.assignmentDocuments && row.assignmentDocuments.length) {
          prepareBtn.push([
            8,
            "Achiziții",
            ["fa-solid fa-gears", "font-size:2.5rem; color:green;"],
          ]);
        }

        if (row.verbalProcess && row.verbalProcess.length) {
          prepareBtn.push([
            9,
            "Procese verbale",
            ["fas fa-folder", "font-size:2.2rem; color:green; "],
          ]);
        }

        if (row.announcement && row.announcement.length) {
          prepareBtn.push([
            10,
            "Anunțuri",
            ["fas fa-bullhorn", "font-size:2.2rem; color:green; "],
          ]);
        }

        preparation.push([prepareBtn]);

        if (o.minimize) {
          preparation.splice(0, 0, {
            val: i,
            border: "right",
          });
          preparations.push(preparation);
        } else {
          if (o.numerotate) {
            preparation.splice(0, 0, {
              val: i,
              border: "right",
            });
          }

          const id = row.id ? row.id : "-";

          const returnData = { id, row: preparation, data: row, _Data: row };

          preparations.push(returnData);
        }
        i++;
      }

      if (o.minimize) {
        preparations.forEach((e, i) => (e._ID = i));
      } else if (o.minimize === false || o.numerotate) {
        preparations.forEach((e, i) => {
          e.NR = i;
          e.index = i;
        });
      }

      return preparations;
    },
  },
  computed: {
    ...mapGetters(["getPaapCentralizationTableData", "getProcedureTypes"]),
    currentProcedureId() {
      return (
        this.getProcedureTypes?.[this.$route.params.procedureType]?.id || ""
      );
    },

    isLoadingMenu() {
      return !this.getProcedureTypes;
    },
  },
  watch: {
    $route: {
      handler() {
        if (!this.isLoadingMenu) {
          this.reloadPage(true);
        }
      },
    },
  },

  created() {
    if (!this.PERMISIONS.list) {
      return;
    }
  },

  mounted() {
    if (this.isLoadingMenu) {
      const unwatch = this.$watch("isLoadingMenu", (val) => {
        if (!val) {
          this.reloadPage();
          unwatch();
        }
      });
    } else {
      this.reloadPage();
    }
  },
};
</script>
